module.exports = __webpack_public_path__ + "img/boss-breaker-4-3.b23c6331.png";